import React from "react";
import { View, TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";
import AppTheme from "../../AppTheme";

export default function Clock(props) {
  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M5.2535 2.26023L4.40016 1.24023L1.3335 3.8069L2.1935 4.8269L5.2535 2.26023ZM14.6668 3.81357L11.6002 1.24023L10.7402 2.26023L13.8068 4.83357L14.6668 3.81357ZM8.00016 2.6669C4.68683 2.6669 2.00016 5.35357 2.00016 8.6669C2.00016 11.9802 4.68016 14.6669 8.00016 14.6669C11.3135 14.6669 14.0002 11.9802 14.0002 8.6669C14.0002 5.35357 11.3135 2.6669 8.00016 2.6669ZM8.00016 13.3336C5.42016 13.3336 3.3335 11.2469 3.3335 8.6669C3.3335 6.0869 5.42016 4.00023 8.00016 4.00023C10.5802 4.00023 12.6668 6.0869 12.6668 8.6669C12.6668 11.2469 10.5802 13.3336 8.00016 13.3336ZM6.00016 7.33357H8.42016L6.00016 10.1336V11.3336H10.0002V10.0002H7.58016L10.0002 7.20023V6.00023H6.00016V7.33357Z"
          fill={AppTheme.almostBlack}
        />
      </Svg>
    </TouchableOpacity>
  );
}
